import { Map } from 'immutable';

import {
  RECIEVE_FINDING,
  RECIEVE_FINDINGS,
  REMOVE_FINDING,
  TOGGLE_FINDING_MESSAGE,
  UPDATE_FINDING_FIELD,
} from './actions/Findings';

const fromId = c => c.reduce((all, x) => ({ ...all, [x.id]: x }), {});
const fromName = c => c.reduce((all, x) => ({ ...all, [x.name]: x }), {});
class Constant {
  constructor(values) {
    this._id_map = fromId(values);
    this._name_name = fromName(values);
  }

  fromId = id => this._id_map[id];

  fromName = name => this._name_name[name];
}

const constantsGenerator = constants =>
  Object.keys(constants)
    .reduce((allConstants, key) => ({
      ...allConstants,
      [key]: new Constant(constants[key]),
    }), {});


// Use Map instead of fromJS because I really don't want all nested children to
// have to use the .get .set api, especially for nested workflows/tags.
const initialState = Map({
  findings: [],
  constants: {
    category: { fromId: {}, fromName: {} },
    resolution: { fromId: {}, fromName: {} },
    status: { fromId: {}, fromName: {} },
    type: { fromId: {}, fromName: {} },
    uiAction: { fromId: {}, fromName: {} },
  },
});


const FindingsReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case RECIEVE_FINDINGS: {
      // showingTextBox and pendingMessage are not returned from API. Instead
      // of tracking these finding-related properties elsewhere, inject into
      // finding object. GraphQL explicitness makes sure this meta-data doesn't
      // get sent to API, and this simplies object tracking.
      const newState = Map({
        findings: action.findings.map(i => ({
          ...i,
          showingTextBox: false,
          pendingMessage: '',
        })),
      });

      // Don't clear constants unless we are replacing it
      if (!action.constants) {
        return newState;
      }

      return newState.set('constants', constantsGenerator(action.constants));
    }
    case RECIEVE_FINDING: {
      const key = state.get('findings').findIndex(x => x.id === action.finding.id);
      return state.setIn(['findings', key], action.finding);
    }
    case REMOVE_FINDING: {
      const key = state.get('findings').findIndex(x => x.id === action.finding.id);
      return state.deleteIn(['findings', key]);
    }
    case TOGGLE_FINDING_MESSAGE: {
      const key = state.get('findings').findIndex(x => x.id === action.id);
      return state.updateIn(['findings', key, 'showingTextBox'], val => !val);
    }
    case UPDATE_FINDING_FIELD: {
      const key = state.get('findings').findIndex(x => x.id === action.id);
      return state.setIn(['findings', key, action.field], action.value);
    }
    default:
      return state;
  }
};

export default FindingsReducer;



// WEBPACK FOOTER //
// ./src/redux/FindingsReducer.js